import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";
import {LocationService} from "../../../commons/services/location-service.service";

export class AgentLocationCtrl implements IController {

  location: any;
  agentId?: string;
  lastUpdate: any;
  showAddress: boolean;
  showText: any;
  direction: any;
  gpsStatus: any;
  locationTrackingApproval: boolean;

  private loading: boolean;
  private agentLocationAddress: any;
  private status: any;

  constructor(private latLngToAddress, private $log, private locationService: LocationService) {
  }

  $onInit() {
    this.loading = false;
    if (_.isUndefined(this.showAddress)) {
      this.showAddress = true;
    }

  }

  $onChanges(changes) {
    if (changes.gpsStatus) {
      this.status = _.isUndefined(this.gpsStatus) ? '' : (!!this.gpsStatus ? 'on' : 'off');
    }
  }

  // getLocation() {
  //   if (!this.agentLocationAddress ||
  //     (this.agentLocationAddress.lat !== this.location?.latitude && this.agentLocationAddress.lng !== this.location?.longitude)) {
  //     this._setLocationAddress(this.location);
  //   }
  // }

  getLocation() {
    if (this.location?.latitude && this.location?.longitude) {
      this._setLocationAddress(this.location);
    } else if (this.agentId) {
      this._setAgentLocation();
    }
  }

  private _setAgentLocation() {
    const payload = {
      holderId: this.agentId,
      holder: LocationHolderType.Agent
    }

    this.loading = true;
    this.locationService.getLocations([payload])
      .then((locations: any) => {
        this.lastUpdate = locations[0].updatedAt;
        this._setLocationAddress(locations[0].coordinates);
      })
      .finally(() => {
        this.loading = false;
      })
  }

  private _setLocationAddress(location) {
    this.loading = true;
    this.latLngToAddress(location.latitude, location.longitude)
      .then((place) => {
        this.agentLocationAddress = {
          lat: location.lat,
          lng: location.lng,
          place: place
        };
      })
      .catch((error) => {
        this.$log.error('Failed to get address by coordinates,' +
          'agentLocation@ctrl.$onInit', error)
      })
      .finally(() => {
        this.loading = false;
      })
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentLocation', {
    bindings: {
      location: '<',
      agentId: '<?',
      lastUpdate: '<',
      showAddress: '<?',
      showText: '<',
      direction: '<?',
      gpsStatus: '<?',
      locationTrackingApproval: '<?'
    },
    template: require('./agent-location.html').default,
    controller: AgentLocationCtrl
  });
